<template>
    <div v-if="products" class="last__seen mb-18 md:mb-27">
        <h2 class="section_title mb-4">
            Tus últimas consultas
        </h2>
        <p class="m-0 tx-purple-1  mb-8">
            En los últimos 30 días
        </p>
        <div class="wrapper-swiper-out swiper-cars">
            <div class="swiper-cars-2 swiper-container grid">
                <swiper class="swiper-wrapper" :options="swiperOptionTop" ref="swiperLastViews">
                    <swiper-slide v-for="(product, key) in products" :key="key">
                        <thumbnail-car-component v-if="product" :product="product"></thumbnail-car-component>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="swiper-button-prev swiper-button-prev-last-views" slot="button-prev">
                <img src="/assets/images/helpers/icon-angle-right.svg" alt="">
            </div>
            <div class="swiper-button-next swiper-button-next-last-views" slot="button-next">
                <img src="/assets/images/helpers/icon-angle-right.svg" alt="">
            </div>
        </div>
    </div>
</template>


<script>
import ThumbnailCarComponent from '../../layout/ThumbnailCarComponent';
import { mapState } from 'vuex';

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    data() {
        return {
            callAsync: false,
            products: null,
            swiperOptionTop: {
                slidesPerView: 'auto',
                freeMode: true,
                spaceBetween: 8,
                 /* NAV */
                navigation: {
                    nextEl: '.swiper-button-next-last-views',
                    prevEl: '.swiper-button-prev-last-views'
                },
                breakpoints: {
                    540: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 16
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 29
                    }
                }
            },

            formData: null,
            err: {}
        }
    },

    computed: {
        ...mapState(['user'])
    },

    watch: {
        user(state) {
            let vm = this;
            vm.getLastViewsProductsAsync();
        },
    },

    components: {
        ThumbnailCarComponent,
        Swiper,
        SwiperSlide
    },

    created() {
        let vm = this;
    },

    methods: {

        async getLastViewsProductsAsync() {
            let vm = this;
            if (!vm.callAsync) {
                vm.resetForms();
                vm.callAsync = true;

                try {
                    vm.formData.append('user_id', vm.user && !!vm.user.id ? vm.user.id : null );

                    let {data} = await axios.post('/client/home/last-views-products', vm.formData);
                    vm.products = data;
                    vm.callAsync = false;
                } catch (error) {
                    console.log(error);
                    vm.callAsync = false;
                }
            }
        },

        showErrors(error = null) {
            let vm = this;
            if ( error ) {
                vm.err = error.response.data;
            }
            vm.$swal({
                icon: 'error',
                title: 'Error',
                text: vm.err.message ? vm.err.message : 'Se encontraron algunos errores en el formulario',
            });
        },

        resetForms() {
            let vm = this;
            vm.formData = new FormData();
            vm.err = [];
        },
    },
}
</script>
